import React, { useCallback, useEffect } from 'react';
import { Col, Form, Row, Table } from 'react-bootstrap';
import { Button as SubmittButton } from '@rd-web-markets/shared/dist/util/buttons';
const ClaimsSelectionFieldYearOnly = _ref => {
  let {
    toggleInclude,
    claims,
    includeSingleClaim,
    loading,
    setFromDate,
    setClaims
  } = _ref;
  useEffect(() => {
    claims.forEach((c, index) => {
      const lastFourCharacters = c.kimble_name.slice(-4);
      const isIncludeInYearList = includeInYearList(lastFourCharacters);
      if (isIncludeInYearList && claims[index].from_date !== "01/01/".concat(lastFourCharacters)) {
        updateDates(lastFourCharacters, index);
      } else if (isIncludeInYearList && claims[index].from_date === "01/01/".concat(lastFourCharacters)) {
        return;
      } else {
        updateDates(new Date().getFullYear(), index);
      }
    });
  }, []); // eslint-disable-line

  const includeClaim = (claim, index, e) => {
    claims.forEach(c => {
      if (c.id_in_provider_system === claim.id_in_provider_system) {
        c.include = e.target.checked;
      }
    });
    setClaims([...claims]);
  };
  const updateDates = (currentYear, index) => {
    claims[index].from_date = '01/01/' + currentYear;
    claims[index].to_date = '31/12/' + currentYear;
    setClaims([...claims]);
  };
  const yearsList = () => {
    const yearList = [];
    for (let i = new Date().getFullYear() + 3; i >= 2010; i--) {
      yearList.push(i);
    }
    return yearList;
  };
  const includeInYearList = useCallback(year => yearsList().includes(Number(year)), []);
  const dropDown = index => {
    return /*#__PURE__*/React.createElement(Form.Control, {
      defaultValue: claims[index].kimble_name.slice(-4),
      as: "select",
      name: "selectedYear",
      onChange: e => updateDates(e.target.value, index),
      size: "md",
      style: {
        width: '100px'
      },
      "data-testid": "years"
    }, /*#__PURE__*/React.createElement("option", {
      key: 'uniqkey',
      value: null
    }), yearsList().map(year => {
      return /*#__PURE__*/React.createElement("option", {
        key: year,
        value: year
      }, year);
    }));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: 3
    }
  }, /*#__PURE__*/React.createElement(Table, {
    className: "table table-hover"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "text-primary app-fs-table-header"
  }, /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "Claim Name"), /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "Select Claim"), /*#__PURE__*/React.createElement("th", {
    className: "font-weight-normal"
  }, "Include?"))), /*#__PURE__*/React.createElement("tbody", null, claims.map((claim, index) => /*#__PURE__*/React.createElement("tr", {
    key: index
  }, /*#__PURE__*/React.createElement("td", null, claim.kimble_name), /*#__PURE__*/React.createElement("td", null, claims.every(c => !!c.from_date) && dropDown(index)), includeSingleClaim ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(SubmittButton, {
    disabled: !claim.from_date,
    variant: "info",
    size: "sm",
    loading: loading,
    onClick: () => toggleInclude(claim)
  }, "Select ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right"))) : /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Form.Check, {
    "data-testid": "include-check",
    className: "text-start",
    type: "checkbox",
    name: "include",
    disabled: !claim.from_date,
    checked: claim.include,
    value: claim.include,
    onChange: e => includeClaim(claim, index, e)
  })))))))));
};
export default ClaimsSelectionFieldYearOnly;